module.exports = __webpack_public_path__ + "imgs/edibles.c72729bb6b5f168276422420d093f0fe.jpg";